export type StoreTypeParam = 'main-store' | 'kitchen-store' | 'prep-store' | 'brand-chef-store';

export const STORE_TYPE_LABELS: Record<StoreTypeParam, string> = {
  'main-store': 'Main store',
  'kitchen-store': 'Kitchen store',
  'prep-store': 'Prep store',
  'brand-chef-store': 'Brand chef store'
};

export type StoreConfig = {
  itemsEndpoint: (storeId?: string) => string;
  batchesEndpoint?: (storeId?: string) => string;
  searchParam: 'name' | 'search';

  getExpiredItems: string;
};

export const STORE_CONFIG: Record<StoreTypeParam, StoreConfig> = {
  'main-store': {
    itemsEndpoint: (storeId = '') => `main-store/${storeId}/items`,
    batchesEndpoint: (storeId = '') => `main-store/${storeId}/batches`,
    getExpiredItems: 'main-store/dashboard',
    searchParam: 'name'
  },
  'kitchen-store': {
    itemsEndpoint: (storeId = '') => `kitchen-store/${storeId}/store-items`,
    batchesEndpoint: (storeId = '') => `kitchen-store/${storeId}/batches`,
    getExpiredItems: 'kitchen-store/dashboard',

    searchParam: 'search'
  },
  'prep-store': {
    itemsEndpoint: (storeId = '') => `kitchen-store/${storeId}/store-items?item_type=prep`,
    getExpiredItems: 'kitchen-store/dashboard',
    batchesEndpoint: (storeId = '') => `kitchen-store/${storeId}/batches?item_type=prep`,

    searchParam: 'name'
  },
  'brand-chef-store': {
    itemsEndpoint: (storeId = '') => `kitchen-store/${storeId}/store-items?item_type=meal`,
    getExpiredItems: 'kitchen-store/dashboard',
    batchesEndpoint: (storeId = '') => `kitchen-store/${storeId}/batches?item_type=meal`,

    searchParam: 'name'
  }
};

export const normalizeStoreType = (
  value: string | undefined,
  fallback: StoreTypeParam
): StoreTypeParam => {
  if (
    value === 'main-store' ||
    value === 'kitchen-store' ||
    value === 'prep-store' ||
    value === 'brand-chef-store'
  ) {
    return value;
  }
  return fallback;
};
